var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"NavigationToggle",class:{ 'NavigationToggle--closed': !this.open }},[_c('span',{staticClass:"NavigationToggle__icon",class:{ 'NavigationToggle__icon--closed': !this.open }})])}
var staticRenderFns = []

export { render, staticRenderFns }